import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.1 },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

// Icons
const StepIcon = ({ children }: any) => (
  <div className="w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xl shadow">
    {children}
  </div>
);

export const HowItWorksPage = () => {
  return (
    <main className="min-h-screen pt-24 bg-background px-6 py-16 max-w-6xl mx-auto text-foreground">
      {/* BREADCRUMBS */}
      <motion.p
        variants={item}
        initial="hidden"
        animate="visible"
        className="text-sm text-foreground/60 mb-6"
      >
        <Link to="/" className="hover:text-primary">
          Home
        </Link>{" "}
        / How It Works
      </motion.p>

      {/* HERO */}
      <motion.div
        variants={container}
        initial="hidden"
        animate="visible"
        className="mb-20 text-center"
      >
        <motion.h1
          variants={item}
          className="text-5xl font-light italic text-primary mb-4"
        >
          How It Works
        </motion.h1>

        <motion.p
          variants={item}
          className="text-lg text-foreground/70 max-w-2xl mx-auto leading-relaxed"
        >
          The Blind Date is designed to give you genuine conversations, not
          endless swipes. Here’s how the magic works.
        </motion.p>
      </motion.div>

      {/* STEPS SECTION */}
      <motion.div
        variants={container}
        initial="hidden"
        animate="visible"
        className="grid md:grid-cols-3 gap-12"
      >
        {/* Step 1 */}
        <motion.div
          variants={item}
          className="bg-card p-8 rounded-xl shadow-sm border border-border text-center"
        >
          <StepIcon>01</StepIcon>

          <h3 className="text-2xl font-semibold mt-6 mb-3">Fill the Form</h3>
          <p className="text-foreground/70 leading-relaxed">
            Tell us about yourself through a thoughtful questionnaire. No small
            talk, only meaningful insights that help us match you better.
          </p>
        </motion.div>

        {/* Step 2 */}
        <motion.div
          variants={item}
          className="bg-card p-8 rounded-xl shadow-sm border border-border text-center"
        >
          <StepIcon>02</StepIcon>

          <h3 className="text-2xl font-semibold mt-6 mb-3">We Match You</h3>
          <p className="text-foreground/70 leading-relaxed">
            Our team personally reviews every submission to create real, human
            matches, not automated algorithms.
          </p>
        </motion.div>

        {/* Step 3 */}
        <motion.div
          variants={item}
          className="bg-card p-8 rounded-xl shadow-sm border border-border text-center"
        >
          <StepIcon>03</StepIcon>

          <h3 className="text-2xl font-semibold mt-6 mb-3">Your Blind Date</h3>
          <p className="text-foreground/70 leading-relaxed">
            If a match is successful, we schedule a date. Only after your match
            is confirmed do you proceed with payment.
          </p>
        </motion.div>
      </motion.div>

      {/* CTA */}
      <motion.div
        className="text-center mt-24"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        <motion.h2
          variants={item}
          className="text-3xl font-light italic text-primary mb-9"
        >
          Ready to Begin Your Journey?
        </motion.h2>

        <motion.div variants={item} whileHover={{ scale: 1.04 }}>
          <Link
            to={"/city-selection"}
            className="px-12 py-4 bg-primary text-primary-foreground rounded-lg font-semibold shadow-lg hover:shadow-xl transition"
          >
            Fill the Form
          </Link>
        </motion.div>
      </motion.div>
    </main>
  );
};
